import { create } from "zustand";
import { getJSON, postJSON } from "../lib/api";

/**
 * Auth store — current user, bootstrap-on-mount, login/signup/logout actions.
 */
export const useAuthStore = create((set, get) => ({
    user: null,
    isLoading: true,
    error: null,

    bootstrap: async () => {
        try {
            const r = await getJSON("/auth/me");
            set({ user: r.user, isLoading: false, error: null });
        } catch (e) {
            // 401 means not logged in — that's fine
            set({ user: null, isLoading: false, error: null });
        }
    },

    refresh: async () => {
        try {
            const r = await getJSON("/auth/me");
            set({ user: r.user });
            return r.user;
        } catch {
            set({ user: null });
            return null;
        }
    },

    login: async (email, password) => {
        const r = await postJSON("/auth/login", { email, password });
        set({ user: r.user, error: null });
        return r.user;
    },

    signup: async (name, email, password) => {
        const r = await postJSON("/auth/signup", { name, email, password });
        set({ user: r.user, error: null });
        return r.user;
    },

    logout: async () => {
        try {
            await postJSON("/auth/logout", {});
        } finally {
            set({ user: null });
        }
    },

    setUser: (u) => set({ user: u }),

    isAuthed: () => !!get().user,
}));
